import expressOrderDialog from './transport-consignment-express-order'

export default {
  title: 'Transport Consignment',
  list: {
    filterTitle: 'Transport Consignment Filters',
    exportTitle: 'Transport Consignment List'
  },
  batch: {
    selectedCount: '{count} selected',
    confirmFee: 'Confirm Fees',
    cancelConfirmFee: 'Cancel Fee Confirmation',
    complete: 'Complete'
  },
  batchComplete: {
    title: 'Batch Complete',
    tip: 'Confirm the completion details for the waybills under the selected consignments. Completion time is optional; if left blank, the waybill and final tracking node will be completed without recording an actual time.',
    confirm: 'Complete',
    cancel: 'Cancel',
    actualTimePlaceholder: 'Select completion time',
    columns: {
      consignmentNo: 'Consignment No.',
      waybillNo: 'Waybill No.',
      actualTime: 'Completion Time'
    }
  },
  actions: {
    add: 'Add',
    expand: 'Expand',
    collapse: 'Collapse',
    detail: 'Detail',
    rateQuery: 'Rate Query',
    inquiry: 'Inquiry',
    spaceInquiry: 'Space Inquiry',
    confirmSpace: 'Confirm Space',
    delegate: 'Delegate',
    delegateSupplier: 'Delegate Supplier',
    contactSupplier: 'Contact Supplier',
    offlineConfirm: 'Offline Confirmation',
    quickOrder: 'Express Order',
    getExpressLabel: 'Get Label',
    split: 'Split',
    resplit: 'Re-split',
    notifyPicking: 'Notify Picking',
    cancelConsignment: 'Cancel Consignment',
    deleteConsignment: 'Delete Consignment',
    confirmDeleteConsignment: 'Confirm Delete',
    delete: 'Delete',
    unfreeze: 'Unfreeze',
    edit: 'Edit',
    share: 'Share',
    print: 'Print',
    operationHistory: 'Operation History'
  },
  resplit: {
    title: 'Re-split',
    confirm: 'Confirm Re-split',
    cancel: 'Cancel',
    strategy: 'Split Method',
    strategyOptions: {
      2: 'Three Segments: Pre-Port | Main Line | Last Mile',
      3: 'Two Segments: Pre-Port + Main Line | Last Mile',
      4: 'Two Segments: Pre-Port | Main Line + Last Mile',
      preMainIndependent: 'Two Segments: Pre-Port | Main Line',
      mainLastIndependent: 'Two Segments: Main Line | Last Mile'
    },
    strategySummaryNames: {
      2: 'Three-segment split',
      3: 'Two-segment split (Pre-Port + Main Line | Last Mile)',
      4: 'Two-segment split (Pre-Port | Main Line + Last Mile)',
      preMainIndependent: 'Two-segment split (Pre-Port | Main Line)',
      mainLastIndependent: 'Two-segment split (Main Line | Last Mile)'
    },
    transportSegments: 'Transport Segments',
    strategyDescription: '{strategy}: the source keeps "{sourceSegment}"; {childSegments} will create new consignments, {count} consignments in total.',
    originWarehouse: 'Origin Warehouse',
    destinationAddress: 'Delivery Address / City',
    loadingEndpoint: 'Main-line Origin Endpoint',
    dischargeEndpoint: 'Main-line Destination Endpoint',
    loadingCountry: 'Origin Country',
    loadingPort: 'Port of Loading',
    dischargeCountry: 'Destination Country',
    dischargePort: 'Port of Discharge',
    selectCountry: 'Select a country',
    selectPort: 'Select a port, airport, or border point',
    portCountryRequired: 'Country is missing. Switch to country mode to select one first.',
    portSearchFailed: 'Port/airport search failed. Reopen the dropdown to retry.',
    willGenerate: 'After re-split:',
    consignmentUnit: 'consignments',
    newPlanTip: '· New consignments retain the matching newly created transport plan(s)',
    sourceOrder: 'Source',
    newOrder: 'New {index}',
    table: {
      consignment: 'Consignment',
      planNo: 'Transport Plan No.',
      transportSegment: 'Transport Segment',
      segmentOrigin: 'Segment Origin',
      segmentDestination: 'Segment Destination'
    },
    entrustedTip: 'The shipment and delivery addresses remain unchanged. The source keeps its supplier and entrustment and receives an actual delivery address; only the directly connected first new consignment receives the matching actual pickup address.',
    notEntrustedTip: 'The shipment and delivery addresses remain unchanged. New consignments are created as not entrusted without supplier, inquiry, rate, fee, billing, tracking, or waybill data. Any confirmed rate tied to the original combined route is cleared.',
    success: 'Transport consignment re-split successfully'
  },
  expand: {
    title: 'Consignment {no}',
    placeholder: 'Expanded content is pending design'
  },
  editDialog: {
    title: 'Edit Transport Consignment',
    createTitle: 'Create Transport Consignment',
    createSubtitle: 'Create a new transport consignment manually',
    save: 'Save',
    cancel: 'Cancel',
    discardConfirmTitle: 'Discard current changes?',
    stay: 'Stay',
    discard: 'Discard Changes',
    addNotify: 'Add Notify Party',
    amountPlaceholder: 'Select calculated result or enter manually',
    calculatedByProducts: 'Calculated from products {amount}',
    goodsReadySingleDay: 'Single Day',
    goodsReadyPeriod: 'Period',
    manualCreate: 'Manual Create'
  },
  offlineConfirmDialog: {
    title: 'Offline Consignment Confirmation',
    content: 'Confirm supplier "{supplier}" has been entrusted offline for consignment {no}? The consignment status will become "Consigned", and rate/space confirmation statuses will become "Irrelevant".',
    okText: 'Confirm Consigned',
    cancelText: 'Cancel'
  },
  offlineSupplierDialog: {
    title: 'Delegate Supplier Offline',
    supplierName: 'Supplier Name',
    supplierNamePlaceholder: 'Select supplier',
    contactName: 'Contact',
    contactNamePlaceholder: 'Enter contact',
    contactPhone: 'Contact Phone',
    contactPhonePlaceholder: 'Enter contact phone',
    contactEmail: 'Email',
    contactEmailPlaceholder: 'Enter email',
    okText: 'Confirm Delegation',
    cancelText: 'Cancel'
  },
  expressCancelDialog: {
    title: 'Cancel Express Consignment',
    content: 'Confirm canceling this express consignment ({no})? The placed express order will be voided and its waybill removed. No email notification will be sent.',
    okText: 'Confirm Cancel',
    cancelText: 'Cancel'
  },
  offlineCancelDialog: {
    title: 'Cancel Consignment',
    content: 'This consignment was confirmed offline. Canceling here only reverts the consignment status in this system. Please cancel the actual consignment on the original offline platform.',
    okText: 'Confirm Cancel',
    cancelText: 'Cancel'
  },
  unfreezeDialog: {
    title: 'Confirm Unfreeze',
    content: 'Unfreeze transport consignment ({no})? Its main status will be restored to In Operation.',
    okText: 'Confirm Unfreeze',
    cancelText: 'Cancel'
  },
  inquiryDialog: {
    title: 'Inquiry',
    segmentTip: 'Inquiry is currently started for this consignment segment only. Cross-segment inquiry is not supported yet.',
    rateQuerySegmentTip: 'Query the rate library by this consignment segment and current route criteria. When multiple business types are selected, query and select independently in each tab.',
    transportRoute: 'Transport Route',
    onePriceSupported: 'All In Price',
    quoteDeadline: 'Quote Deadline',
    goodsReadyDate: 'Date',
    goodsReadyRange: 'Range',
    carrier: 'Carrier',
    shippingCompany: 'Shipping Company',
    airline: 'Airline',
    railwayCompany: 'Railway Company',
    optional: '(optional)',
    carrierUnspecified: 'Unspecified',
    businessModes: 'Select Transport Business Type (multiple)',
    cargoGroup: 'Cargo Group',
    vehicleGroup: 'Vehicle Group',
    bulkCargoInfo: 'Cargo Info',
    summary: 'Total: {qty} pcs / {weight} KGS / {volume} CBM',
    vehicleSummary: 'Total: {qty} vehicles / {weight} KGS',
    bulkSummary: 'Total: {weight} MT / {volume} CBM',
    queryExistingRates: 'Query Existing Rates',
    query: 'Query',
    rateWriteBackFullTip: 'Confirming a rate updates this consignment and connecting routes on related consignments. Determine the route containing the main leg first. Confirmation is allowed when the selected connecting route values are blank or match the related consignment, even if it is already consigned. Blank values do not clear existing related routes. Non-empty selected values that differ from a consigned related order block updates to both orders. For unconsigned related orders, blank fields are filled automatically; other differences require confirmation to overwrite, or you can cancel and reselect.',
    rateWriteBackShortTip: 'Confirmation also updates matching routes on related consignments. Determine the route containing the main leg first.',
    routeInfo: 'Route Information',
    routeFilterTitle: 'Route Information Filters',
    expand: 'Expand',
    collapse: 'Collapse',
    originCountry: 'Origin Country',
    destinationCountry: 'Destination Country',
    loadingPort: 'Loading Port/Airport',
    dischargePort: 'Discharge Port/Airport',
    loadingAirport: 'Departure Airport',
    dischargeAirport: 'Arrival Airport',
    originWarehouse: 'Origin Warehouse',
    destinationWarehouse: 'Destination Warehouse',
    originPlace: 'Origin',
    destinationPlace: 'Destination',
    routeConflictTitle: 'Related consignment connecting route conflict',
    routeConflictContent: 'A related consignment has non-empty route fields that differ from this consignment. Use this consignment value to overwrite them?',
    routeConflictDescription: 'The following connecting loading/discharge ports, airports or countries differ from the existing non-empty values on the related consignment. When it is not consigned, confirm to overwrite them with the selected rate values, or cancel and reselect.',
    routeBlockedDescription: 'Related consignment(s) [{nos}] are already consigned, and the selected rate has non-empty connecting route values (loading/discharge ports, airports or countries) that differ from those consignments. This confirmation cannot update either consignment. Cancel and reselect.',
    sameSegmentBlockedTitle: 'Duplicate transport segment detected',
    sameSegmentBlockedDescription: 'Related consignment(s) [{nos}] have the same transport segment as this consignment. Resolve the duplicate consignments before confirming the rate.',
    confirmRouteWriteBack: 'Confirm Write-back',
    routeConflictColumns: {
      relatedConsignmentNo: 'Related Consignment',
      transportSegment: 'Transport Segment',
      field: 'Field',
      relatedCurrent: 'Related Current Value',
      proposed: 'This Consignment Value'
    },
    useCurrentRoute: 'Use This Consignment',
    cancelAndReselect: 'Cancel and Reselect',
    routeBlockedTitle: 'Connecting route conflict with a consigned order',
    routeBlockedContent: 'Related consignment(s) [{nos}] are already consigned, and the selected rate has non-empty connecting route values that differ from those consignments. This confirmation will not update either consignment. Cancel and reselect.',
    rateResults: {
      found: 'Found {count}',
      tabFcl: 'FCL',
      tabLcl: 'LCL',
      tabAir: 'Air',
      tabPrePort: 'Pre-port Trucking',
      tabLastMile: 'Last-mile Trucking',
      tabFullCombination: 'Full-route Combination',
      tabPreMainCombination: 'Pre-port + Main-leg Combination',
      tabMainLastCombination: 'Main-leg + Last-mile Combination',
      routePorts: 'POL / POD',
      originAirportLabel: 'Origin Airport',
      destinationAirportLabel: 'Destination Airport',
      countUnit: '',
      sourceContract: 'Contract',
      sourceInquiry: 'Inquiry',
      sourceQuotation: 'Quotation',
      sourceManual: 'Manual',
      sortLabel: 'Sort: ',
      sortPrice: 'Best Price',
      sortTransit: 'Fastest',
      transitLabel: 'Transit: ',
      dayUnit: ' days',
      validLabel: 'Valid until: ',
      validity: 'Validity',
      validityLabel: 'Validity: ',
      etdLabel: 'Earliest ETD: ',
      minChargeLabel: 'Min Charge',
      wmUnitRateLabel: 'W/M Rate',
      kgUnitRateLabel: 'KG Rate',
      baseFreightUnitLabel: 'Base Freight',
      airWeightTierUnitRateLabel: '{tier} Unit Rate',
      normalRateUnitRateLabel: 'N Rate',
      applicableAirRateLabel: 'Applicable Rate',
      estimatedFreightLabel: 'Estimated Freight',
      chargeableWeightLabel: 'Chargeable Weight: ',
      chargeableWeightValue: '{value} KG',
      calculatedFreightLabel: 'Calculated Freight: ',
      minimumChargeDetailLabel: 'Minimum Charge: ',
      minimumAppliedLabel: ' (Applied)',
      minShipmentLabel: 'Minimum Shipment',
      totalPriceLabel: 'Total Cost',
      priceRangeLabel: 'Price Range',
      roadTransport: 'Trucking',
      roadPriceUnit: '/shipment',
      minMaxUnit: 'Min/Max',
      ticketUnit: '/shipment',
      ticketStartUnit: '/shipment min',
      airPriceLabel: 'Rate/kg',
      remarksTitle: 'Remarks',
      supplierLabel: 'Supplier: ',
      laneCodeLabel: 'Lane Code: ',
      airlineLabel: 'Airline: ',
      priceNoLabel: 'Rate Code: ',
      fullCombinationPrePort: 'Pre-port: ',
      fullCombinationTrunk: 'Main leg: ',
      fullCombinationLastMile: 'Last-mile: ',
      fullCombinationRoute: 'Full route: ',
      fullCombinationPrePortNo: 'Pre-port Rate: ',
      fullCombinationTrunkNo: 'Main-leg Rate: ',
      fullCombinationLastMileNo: 'Last-mile Rate: ',
      receivingLabel: 'Receiving: ',
      shippingTipLabel: 'Shipping Tip: ',
      weightLimitText: 'Weight limit {value}T',
      freeBoxLabel: 'Free Storage: ',
      freeBoxSeparator: ', ',
      detentionDays: 'Free detention {days}d',
      demurrageDays: 'Free demurrage {days}d',
      remarkLabel: 'Note: ',
      cargoTypeText: 'Cargo Type {value}',
      cargoDescText: 'Cargo Description {value}',
      spotQuote: 'Contact for quote',
      periodEndOnly: 'Until {date}',
      periodStartOnly: 'From {date}',
      directAir: 'Direct Flight',
      directSea: 'Direct',
      transfer: 'Transfer',
      directTransferAir: 'Direct + Transfer',
      directTransferSea: 'Direct + Transfer',
      unspecified: 'Unspecified',
      weekdaySeparator: ', ',
      weekdays: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun'
      },
      specialInstructionsLabel: 'Special: ',
      noResults: 'No matching rates found',
      noResultsValidityHint: 'Please verify whether the expected pickup/delivery time for this segment falls within the rate validity period.'
    },
    shouldInquiry: 'Inquiry',
    missingIsoCode: ' (missing ISO code)',
    containerTypeLoadFailed: 'Failed to load container type basic data',
    supplierSelector: {
      searchPlaceholder: 'Search supplier name or contact keyword',
      region: 'Region',
      notSet: 'Not set',
      noData: 'No matching suppliers',
      noContacts: 'No contacts',
      selectSupplier: 'Select a supplier to view details',
      selectAll: 'Select All',
      selectedCount: '{count} contacts selected',
      contact: 'Contact',
      phone: 'Phone',
      email: 'Email',
      evaluation: 'Supplier evaluation',
      noEvaluation: 'No supplier evaluation',
      noEvaluationItems: 'No evaluation item details',
      modeUnsupported: 'Select a supported inquiry business type before querying suppliers',
      loadFailed: 'Failed to load inquiry target suppliers'
    },
    addContainer: 'Add Container',
    addCargo: 'Add Cargo',
    addVehicle: 'Add Vehicle',
    addBulkCargo: 'Add Cargo Info',
    delete: 'Delete',
    cancel: 'Cancel',
    close: 'Close',
    confirm: 'Confirm',
    confirmSelection: 'Confirm Selection',
    routes: {
      direct: 'Direct',
      transfer: 'Transfer',
      unspecified: 'Unspecified'
    },
    fieldLabels: {
      containerType: 'Container Type',
      containerQty: 'Qty',
      outboxQty: 'Packages',
      containerWeight: 'Weight (KGS)',
      containerSize: 'Size (L×W×H cm)',
      containerLength: 'L (cm)',
      containerWidth: 'W (cm)',
      containerHeight: 'H (cm)',
      packaging: 'Packaging Type',
      grossWeight: 'Gross Weight (KGS)',
      volume: 'Volume (CBM)',
      length: 'Length (cm)',
      width: 'Width (cm)',
      height: 'Height (cm)',
      palletQty: 'Pallet Qty',
      vehicleType: 'Vehicle Type',
      vehicleQty: 'Qty',
      vehicleBrand: 'Brand',
      vehicleModel: 'Model',
      brand: 'Brand',
      model: 'Model',
      vehicleLength: 'Length (M)',
      vehicleWidth: 'Width (M)',
      vehicleHeight: 'Height (M)',
      vehicleWeight: 'Gross Weight (KGS)',
      cargoKind: 'Cargo Kind',
      cargoWeight: 'Tonnage (MT)',
      cargoVolume: 'Volume (CBM)',
      tonnage: 'Tonnage (MT)',
      stowageFactor: 'Stowage Factor',
      summaryRow: 'Summary',
      totalVehicleQty: 'Total Vehicles',
      totalVehicleWeight: 'Total Gross Weight',
      vehicleRlm: 'RLM',
      totalTonnage: 'Total Tonnage',
      totalCubage: 'Total Volume',
      averageStowageFactor: 'Avg Stowage Factor',
      packagingType: 'Packaging',
      remark: 'Remark',
      remarks: 'Remarks',
      operation: 'Action'
    },
    vehicleTypes: {
      sedan: 'Sedan',
      suv: 'SUV',
      mpv: 'MPV',
      pickup: 'Pickup',
      truck: 'Truck',
      bus: 'Bus',
      machinery: 'Machinery',
      other: 'Other'
    },
    cargoKinds: {
      steel: 'Steel',
      coal: 'Coal',
      ore: 'Ore',
      grain: 'Grain',
      timber: 'Timber',
      fertilizer: 'Fertilizer',
      cement: 'Cement',
      sandStone: 'Sand/Stone',
      other: 'Other'
    },
    placeholders: {
      containerType: 'Select container type',
      transportTerms: 'Select transport terms',
      cargoType: 'Select cargo type',
      quoteDeadline: 'Select quote deadline',
      goodsReadyTimeType: 'Select goods ready time type',
      goodsReadyTime: 'Select goods ready date',
      goodsReadyTimeStart: 'Start date',
      goodsReadyTimeEnd: 'End date',
      shippingCompany: 'Select shipping company',
      airline: 'Select airline',
      railwayCompany: 'Enter railway company',
      packaging: 'Select packaging type',
      grossWeight: 'Gross Weight (KGS)',
      volume: 'Volume (CBM)',
      length: 'L',
      width: 'W',
      height: 'H',
      vehicleType: 'Select vehicle type',
      brand: 'Enter brand',
      model: 'Enter model',
      cargoKind: 'Select cargo kind',
      packagingType: 'Select packaging',
      remark: 'Remark'
    }
  },
  selectedRate: {
    title: 'Selected Rate',
    loading: 'Loading selected rate',
    noData: 'No bound rate found',
    feeDetail: 'Fee Details',
    sailingConfirmTip: 'Recommend space inquiry confirmation: {fields} missing',
    fields: {
      etd: 'ETD: ',
      eta: 'ETA: ',
      vesselVoyage: 'Vessel/Voyage: ',
      flightNo: 'Flight No.: ',
      vesselNameOnly: 'vessel',
      voyageNoOnly: 'voyage',
      laneCodeOnly: 'lane code',
      airlineOnly: 'airline',
      flightNoOnly: 'flight no.'
    }
  },
  tracking: {
    empty: 'No tracking records',
    fields: {
      waybillNo: 'Waybill No.',
      expressNo: 'Express No.',
      supplierName: 'Supplier/Express',
      trackingNode: 'Tracking Node',
      trackingTime: 'Node Time',
      trackingDesc: 'Node Description',
      trackingSource: 'Source',
      operator: 'Operator',
      orderStatus: 'Main Status',
      hasException: 'Exception'
    },
    waybill: {
      actions: {
        create: 'Create Waybill',
        refreshTracking: 'Refresh Tracking',
        packingDetail: 'Packing Details',
        getPod: 'Get POD',
        podFetching: 'Getting POD',
        podFetched: 'POD Retrieved',
        deleteWaybill: 'Delete Waybill',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      docType: {
        transportWaybill: 'Transport Waybill'
      },
      empty: {
        notConsigned: 'This consignment has not been delegated. No tracking records yet.',
        noWaybill: 'No waybill tracking records',
        noNode: 'No tracking nodes'
      },
      tooltip: {
        notConsigned: 'The consignment has not been delegated, so waybill creation is unavailable',
        waybillNo: 'Sea: HBL/MBL; Air: HAWB/MAWB; Express: express waybill no.; Land: carrier waybill no.; Rail: railway waybill no.'
      },
      modal: {
        title: 'Create Waybill',
        baseInfo: 'Basic Info',
        transportInfo: 'Transport Info'
      },
      pod: {
        title: 'Get POD',
        loading: 'Retrieving POD...',
        success: 'POD retrieved successfully!',
        saved: 'Saved to File Management and the signed-node attachments',
        failed: 'Failed to retrieve POD',
        retry: 'Retry',
        close: 'Close',
        defaultError: 'Failed to retrieve POD. Please try again later.',
        stillPending: 'The carrier has not returned a proof of delivery yet. Please try again later.',
        serviceUnavailable: 'The POD service is temporarily unavailable. Please try again later.',
        trackingNoMissing: 'This waybill has no express tracking number available for POD retrieval.',
        fileSaveFailed: 'Failed to save the POD file. Please try again later.',
        recordSaveFailed: 'Failed to save the POD request record. Please try again later.',
        invalidResponse: 'The POD service returned an unrecognized response. Please try again later.',
        statusFailed: 'Failed to query POD status',
        fetchFailed: 'Failed to retrieve POD'
      },
      deleteConfirm: {
        title: 'Delete waybill?',
        content: 'After deleting waybill {no}, the waybill list and tracking data on this page will be deleted as well.',
        okText: 'Delete',
        cancelText: 'Cancel'
      },
      placeholders: {
        select: 'Select {field}',
        packageBarcode: 'Enter a barcode and press Enter to add'
      },
      timePrefixes: {
        estimated: 'Est.',
        actual: 'Act.'
      },
      duration: {
        dayHour: '{days}d {hours}h',
        day: '{value}d',
        hour: '{value}h'
      },
      fields: {
        mainTransportMode: 'Transport Mode',
        blType: 'Waybill No. - BL Type',
        blNo: 'Waybill No. - BL No.',
        expressWaybillNo: 'Waybill No. - Express No.',
        orderNo: 'Waybill No. - Cooperation No.',
        segmentOrigin: 'Segment Origin',
        segmentDestination: 'Segment Destination',
        originPort: 'POL',
        destinationPort: 'POD',
        transshipmentPort: 'Transshipment Port',
        originAirport: 'Origin Airport',
        destinationAirport: 'Destination Airport',
        transshipmentAirport: 'Transfer Airport',
        originPlace: 'Origin',
        destinationPlace: 'Destination',
        originStation: 'Origin Station',
        destinationStation: 'Destination Station',
        shipowner: 'Shipping Company',
        vesselName: 'Vessel',
        voyageNo: 'Voyage',
        lineCode: 'Line Code',
        airline: 'Airline',
        flightNo: 'Flight No.',
        truckCo: 'Truck Company',
        vehicleLicence: 'Vehicle Plate',
        driverName: 'Driver Name',
        driverPhone: 'Phone',
        driverIdNo: 'ID No.',
        vehicleType: 'Vehicle Type',
        railwayCo: 'Railway Company',
        trainNo: 'Train No.',
        expressCompany: 'Express Company',
        expressCarrier: 'Express Carrier',
        expressProduct: 'Express Product',
        packageBarcode: 'Package Barcode',
        supplierName: 'Supplier',
        remark: 'Remark',
        consignmentNo: 'Related Consignment No.',
        fhNo: 'Related FH No.',
        transportSegment: 'Transport Segment',
        transportTool: 'Transport Tool',
        shipper: 'Carrier',
        createdAt: 'Created At',
        exceptionLevel: 'Exception Level',
        estimatedTime: 'Estimated Time',
        actualTime: 'Actual Time',
        estimatedRemark: 'Estimated Remark',
        actualRemark: 'Actual Remark',
        exceptionRemark: 'Exception Remark',
        attachment: 'Attachment'
      },
      summary: {
        separator: ': ',
        relatedWaybillNo: 'Related Waybill No.',
        shippingCompany: 'Shipping Company',
        vesselName: 'Vessel',
        voyageNo: 'Voyage',
        lineCode: 'Line Code',
        airline: 'Airline',
        flightNo: 'Flight No.',
        aircraftType: 'Aircraft Type',
        expectedDuration: 'Expected Duration',
        actualDuration: 'Actual Duration',
        expressCarrier: 'Express Carrier',
        expressProduct: 'Express Product',
        railTrain: 'Rail Train',
        vehicleLicence: 'Vehicle Plate'
      },
      messages: {
        loadFailed: 'Failed to load waybill tracking',
        notConsigned: 'The consignment has not been delegated, so waybill creation is unavailable',
        transportModeRequired: 'The current consignment has no transport mode, so waybill creation is unavailable',
        blTypeRequired: 'Select BL type',
        blNoRequired: 'Enter BL no.',
        expressWaybillNoRequired: 'Enter express waybill no.',
        packageBarcodeRequired: 'At least one package barcode is required for DHL',
        packageBarcodeDuplicate: 'Package barcodes cannot be duplicated',
        orderNoRequired: 'Enter cooperation no.',
        vehicleLicenceRequired: 'Enter vehicle plate',
        truckPlateInvalid: 'Invalid vehicle plate format',
        orderIdRequired: 'Missing consignment ID, so waybill creation is unavailable',
        waybillIdRequired: 'Waybill ID is missing; cannot delete',
        createSuccess: 'Waybill created',
        createFailed: 'Failed to create waybill',
        deleteSuccess: 'Waybill deleted',
        deleteFailed: 'Failed to delete waybill, please try again',
        etowerRetrySuccess: 'Push task resubmitted',
        etowerAlreadySuccess: 'The order was pushed successfully; no retry is needed',
        etowerUnknownWarning: 'The push result is unknown; check it manually first',
        etowerRetryFailed: 'Failed to retry the order push, please try again',
        shipownerLoadFailed: 'Failed to load shipping company data',
        airlineLoadFailed: 'Failed to load airline data',
        expressCarrierLoadFailed: 'Failed to load express carrier data',
        fieldRequired: '{field} is required',
        destinationEqualsOrigin: '{destination} cannot be the same as {origin}',
        timeOrderInvalid: 'ETA cannot be earlier than ETD',
        trackingSaveInvalid: 'Tracking node cannot be saved because the waybill no. or node key is missing'
      },
      tags: {
        bl: 'BL',
        express: 'Express',
        land: 'Land',
        rail: 'Rail',
        waybill: 'Waybill'
      },
      statuses: {
        PENDING: 'Pending',
        IN_PROGRESS: 'In Progress',
        COMPLETED: 'Completed'
      },
      exceptionLevels: {
        normal: 'Normal',
        minor: 'Minor',
        major: 'Major',
        critical: 'Critical'
      }
    }
  },
  common: {
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    noData: 'No data',
    totalItems: '{count} items'
  },
  detail: {
    tabs: {
      basic: 'Basic Info',
      products: 'Product Details',
      tracking: 'Tracking',
      cost: 'Cost',
      billing: 'Billing',
      files: 'File Management',
      bizStatus: 'Business Status'
    },
    sections: {
      base: 'Consignment Basic Info',
      createBase: 'Basic Info',
      source: 'Source Selection',
      bizTags: 'Business Tags',
      logistics: 'Logistics Info',
      party: 'Party Info',
      supplier: 'Supplier Info',
      weightVolume: 'Packages, Weight and Dimensions',
      containerGroup: 'Container Group',
      products: 'Product Details',
      tracking: 'Waybill Tracking',
      cost: 'Cost Info',
      billing: 'Billing Info',
      files: 'File Management',
      bizStatus: 'Business Status'
    },
    supplierExternalLink: {
      open: 'Open Link'
    },
    fedexFileUploadRetry: {
      title: 'Failed to upload FedEx files to eTower',
      description: 'The express order was placed successfully and does not need to be placed again. Retry the selected file upload.',
      action: 'Retry Upload'
    },
    productFilterTitle: 'Product Detail Filters',
    productSummary: '{qty} pcs / {boxes} boxes / Net Total USD {amount}',
    productSummaryFields: {
      totalQuantity: 'Total Quantity',
      productAmount: 'Product Amount',
      totalTax: 'Total Tax',
      customsAmount: 'Customs Value',
      clearanceAmount: 'Clearance Value'
    },
    statusLabels: {
      price: 'Rate ',
      shippingSpace: 'Space '
    },
    unknownOperator: 'Unknown User',
    basicFields: {
      expectShipDate: 'Expected Shipping Time',
      actShipDate: 'Actual Shipping Time',
      expectArrivalDate: 'Expected Arrival Time',
      actArrivalDate: 'Actual Arrival Time',
      updater: 'Updater'
    },
    logisticsFields: {
      crossBorder: 'Cross-border',
      logisticsFlow: 'Logistics Flow',
      goodsValue: 'Goods Value'
    },
    weightVolumeFields: {
      source: 'Data Source',
      totalQty: 'Total Qty',
      totalBoxQty: 'Cartons',
      totalVolume: 'Total Volume',
      totalWeight: 'Total Weight',
      chargeableWeight: 'Chargeable Weight',
      length: 'Length',
      width: 'Width',
      height: 'Height'
    },
    weightVolumeRows: {
      expected: 'Expected',
      warehouse: 'Warehouse Data',
      forwarder: 'Forwarder Data'
    },
    containerFields: {
      containerType: 'Container Type',
      containerQty: 'Qty',
      outboxQty: 'Packages',
      weight: 'Weight (KGS)',
      size: 'Size (L×W×H cm)'
    },
    productFields: {
      lineNo: 'Line No.',
      skuCode: 'SKU / Material Code',
      productName: 'Product Name',
      relatePlanNo: 'Related Transport Plan No.',
      relateFhNo: 'Related Shipping Request No.',
      planNo: 'Source Plan No.',
      fhNo: 'Related FH No.',
      originOrderNo: 'Upstream Order No.',
      originOrderType: 'Upstream Document Type',
      productModel: 'Product Model',
      brand: 'Brand',
      specialAttributes: 'Special Product Attributes',
      barCode: 'UPC Barcode',
      pcsQty: 'Quantity',
      boxGauge: 'Outer Box Spec',
      stdBoxQty: 'Std Box Qty',
      actualBoxQty: 'Actual Boxes',
      packingMethod: 'Packing Method',
      unit: 'Unit',
      unitPrice: 'Unit Price',
      amtNet: 'Net Amount',
      amtNetUntaxed: 'Untaxed Amount',
      amountOrigin: 'Original Amount',
      unitPriceOrigin: 'Original Unit Price',
      unitPriceAll: 'Tax-included Unit Price',
      unitPriceNet: 'Tax-excluded Unit Price',
      amtnFh: 'Tax-included Amount',
      tax: 'Tax',
      taxRto: 'Tax Rate',
      unitPriceQg: 'Clearance Net Unit Price',
      amountNetQg: 'Clearance Net Amount',
      amountTaxQg: 'Clearance Tax',
      amountAllQg: 'Clearance Gross Amount',
      currencyQg: 'Clearance Currency',
      unitPriceBg: 'Customs Net Unit Price',
      amountNetBg: 'Customs Net Amount',
      amountTaxBg: 'Customs Tax',
      amountAllBg: 'Customs Gross Amount',
      currencyBg: 'Customs Currency',
      hsCodeLine: 'HS Code',
      cusPoNo: 'Customer PO No.',
      cnDesc: 'Chinese Description',
      enDesc: 'English Description',
      customsDecl: 'Customs Declaration',
      boxNo: 'Carton No.',
      snNo: 'SN No.',
      snNos: 'SN No.',
      containerNo: 'Container No.',
      sealNo: 'Seal No.',
      cabinetSealNo: 'Container No. (Seal No.)',
      palletNo: 'Pallet No.'
    },
    productActions: {
      add: 'Add Product',
      batchImport: 'Batch Import',
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      deleteConfirm: 'Delete this product detail? It takes effect after saving.',
      downloadTemplate: 'Download Template',
      selectImportFile: 'Select Excel'
    },
    productImport: {
      title: 'Batch Import Product Details',
      description: 'Download the template first, fill it in, then import it. Imported rows are appended to the current product table and take effect after saving.',
      templateFileName: 'Product_Detail_Import_Template.xlsx'
    },
    partyFields: {
      partyType: 'Type',
      company: 'Company',
      contactName: 'Contact',
      phone: 'Phone',
      country: 'Country',
      province: 'Province/State',
      city: 'City',
      district: 'District',
      address: 'Address',
      postcode: 'Postcode'
    },
    partyTypes: {
      shipper: 'Shipper',
      consignee: 'Consignee',
      notify: 'Notify Party',
      customsShipper: 'Customs Shipper Address',
      customsConsignee: 'Customs Consignee Address',
      clearanceShipper: 'Clearance Shipper Address',
      clearanceConsignee: 'Clearance Consignee Address',
      actualPickup: 'Actual Pickup Address',
      actualDelivery: 'Actual Delivery Address'
    },
    tableFields: {
      consignmentNo: 'Transport Consignment No.',
      feeDirection: 'AR/AP',
      feeSegment: 'Fee Segment',
      feeName: 'Fee Name',
      settlementObject: 'Settlement Party',
      domesticForeign: 'Domestic/Foreign',
      costItem: 'Cost Item',
      currency: 'Currency',
      exchangeRate: 'Exchange Rate',
      billingUnit: 'Unit',
      quantity: 'Quantity',
      unitPrice: 'Unit Price',
      inclusiveTaxPrice: 'Tax Included',
      exclusiveTaxPrice: 'Tax Excluded',
      estimatedInclusiveTaxPrice: 'Estimated Amount (Tax Included)',
      estimatedExclusiveTaxPrice: 'Estimated Amount (Tax Excluded)',
      taxRate: 'Tax Rate',
      taxAmount: 'Tax Amount',
      baseCurrency: 'Base Currency',
      baseCurrencyAmount: 'Base Currency Amount',
      writeOffStatus: 'Write-off Status',
      counterpartyBillNo: 'Counterparty Bill No.',
      writeOffAmount: 'Write-off Amount',
      unwrittenOffAmount: 'Unwritten-off Amount',
      writeOffDate: 'Write-off Date',
      receiptPaymentDate: 'Receipt/Payment Date',
      reconciliationStatus: 'Reconciliation Status',
      invoiceType: 'Invoice Type',
      invoiceTitle: 'Invoice Title',
      invoiceDate: 'Invoice Date',
      invoiceNo: 'Invoice No.',
      estimatePushStatus: 'Estimate Push Status',
      settlementPushStatus: 'Settlement Push Status',
      settlementFlag: 'Settlement',
      waybillNo: 'Waybill No.',
      nsAccrualNo: 'NS Accrual No.',
      createTime: 'Created At',
      createdBy: 'Created By',
      modifyTime: 'Updated At',
      modifiedBy: 'Updated By',
      amount: 'Amount',
      status: 'Status',
      remark: 'Remark',
      billNo: 'Bill No.',
      node: 'Node',
      time: 'Time',
      operator: 'Operator',
      operation: 'Action'
    },
    feeColumns: {
      settings: 'Set Columns',
      hint: 'Controls columns in both receivable and payable tables',
      search: 'Search column names',
      autoSave: 'Changes are saved automatically for your next login',
      saving: 'Saving column settings…',
      saved: 'Column settings saved',
      loadFailed: 'Could not load column settings. Retry before making changes.',
      saveFailed: 'Could not save column settings. Please retry.',
      retry: 'Retry',
      validationRevealed: 'Hidden columns with validation errors are temporarily visible. Your column settings are unchanged.',
      consignmentModule: 'Transport Consignment Fee Columns',
      shipmentModule: 'Shipment Request Fee Columns'
    },
    feeSummary: {
      total: 'Fee Total (Tax Included)',
      subtotal: 'Subtotal (Tax Included)'
    },
    feeEdit: {
      addRow: 'Add Row',
      edit: 'Edit',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      deleteConfirmTitle: 'Confirm Fee Deletion',
      deleteConfirmContent: 'Delete fee "{name}"?',
      deleteSingleConfirmContent: 'Delete this fee item? This cannot be undone.',
      deleteSelectedConfirmContent: 'Delete the selected {count} fees? Changes take effect after saving.',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Fee deleted',
      deleteFailed: 'Failed to delete fee',
      selectRowsFirst: 'Select fee rows first',
      selectPlaceholder: 'Select',
      requiredPlaceholder: 'Required',
      requiredMessage: 'Enter {field}',
      validationFailed: 'Complete required fee fields',
      missingOrderId: 'Missing order ID. Fee cannot be saved.',
      orderId: 'Order ID'
    },
    feeAutoImport: {
      partialHint: 'Some fees could not be imported automatically. Please add them manually.',
      failedHint: 'Automatic fee import failed. Enter fees manually or click Re-import.',
      reimport: 'Re-import',
      reimportSuccess: 'Quotation fees re-imported',
      reimportFailed: 'Failed to re-import quotation fees'
    },
    feeConfirm: {
      billCreateBlocked: 'Transport consignment fees are not confirmed. Bill cannot be created.'
    },
    feeChangeRequest: {
      trigger: 'Request Fee Change',
      title: 'Fee Change',
      comparisonTitle: 'Before and After Comparison',
      edit: 'Edit',
      close: 'Close',
      submit: 'Submit',
      submitSuccess: 'Fee change application submitted for approval',
      submitFailed: 'Failed to submit fee change application',
      pendingQueryFailed: 'Failed to check the fee change approval status',
      pendingNotice: 'Note: The current fee change is already pending approval. You can request another fee adjustment after this change is completed.',
      before: 'Before Change',
      after: 'After Change',
      cancel: 'Cancel',
      add: 'Add',
      delete: 'Delete'
    },
    feeChangeApproval: {
      back: 'Back',
      title: 'Fee Change Approval',
      comparisonTitle: 'Fee Change Before and After Comparison',
      consignmentNo: 'Transport Consignment No.',
      applicationNo: 'Fee Change Application No.',
      status: 'Application Status',
      statusValues: {
        draft: 'Draft',
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected'
      },
      submittedAt: 'Submitted At',
      remark: 'Application Remark',
      loadFailed: 'Failed to load fee change approval details',
      missingApplicationId: 'Missing fee change application ID'
    },
    feeAllocation: {
      trigger: 'Allocate Fees',
      allocatedStatus: 'Allocated to {count} distribution shipments',
      status: 'Related distribution shipments: {count}. Allocation basis: chargeable weight',
      sourceBanner: 'This distribution shipment fee was automatically allocated from transport consignment {sourceOrderNo} (chargeable weight {basisValue} / {basisTotal} = {ratio}). To adjust it, update the fee tab on the transport consignment and allocate again.',
      title: 'Fee Allocation',
      modalTip: 'Allocate fees from transport consignment {consignmentNo} to each distribution shipment by chargeable weight ratio. You can allocate again after fee changes.',
      relatedShipments: 'Related Distribution Shipments',
      confirm: 'Confirm Allocation',
      saveBeforeAllocate: 'Save fees before allocation',
      confirmBeforeAllocate: 'Fees are not confirmed. Confirm fees on the list page before allocating.',
      noRelatedShipments: 'No related delivery application orders. Allocation is unavailable.',
      missingConsignmentId: 'Missing transport consignment ID',
      previewTitle: 'Allocated Amount Preview',
      previewTitleWithShipment: 'Allocated Amount Preview ({shipmentNo} · {billingWeight} · {ratio})',
      shipmentNo: 'Distribution Shipment No.',
      chargeWeightKg: 'Chargeable Weight (kg)',
      ratio: 'Allocation Ratio',
      originalInclusiveAmount: 'Total Amount (Tax Included)',
      allocatedAmount: 'Allocated Amount',
      loadPreviewFailed: 'Failed to load fee allocation preview',
      success: 'Fee allocation succeeded',
      failed: 'Fee allocation failed'
    },
    feeEnums: {
      feeType: {
        receivable: 'Receivable',
        payable: 'Payable'
      },
      domesticForeign: {
        domestic: 'Domestic',
        foreign: 'Foreign'
      },
      writeOffStatus: {
        unwritten: 'Not Written Off',
        written: 'Written Off',
        partial: 'Partially Written Off'
      },
      reconciliationStatus: {
        unchecked: 'Unreconciled',
        checked: 'Reconciled',
        rejected: 'Rejected'
      },
      pushStatus: {
        unpushed: 'Not Pushed',
        pushed: 'Pushed'
      },
      settlementPushStatus: {
        unsettled: 'Unsettled',
        settled: 'Settled'
      },
      settlementFlag: {
        Y: 'Yes',
        N: 'No'
      }
    },
    customerVisible: 'Customer Visible',
    fileFields: {
      fileName: 'File Name',
      fileType: 'File Type',
      fileFormat: 'File Format',
      uploader: 'Uploader',
      uploadTime: 'Upload Time',
      fileSize: 'File Size',
      source: 'Source',
      actions: 'Actions'
    },
    businessStatusFields: {
      logSeq: 'No.',
      opTime: 'Operation Time',
      opUser: 'Operator',
      content: 'Operation Content'
    },
    fileActions: {
      upload: 'Upload File',
      importReport: 'Import Report',
      download: 'Download',
      delete: 'Delete'
    },
    deleteFileConfirm: 'Delete file "{fileName}"?',
    uploadFile: {
      title: 'Upload File',
      fileType: 'File Type',
      fileTypePlaceholder: 'Select file type',
      file: 'File',
      selectFile: 'Select Local File',
      filePlaceholder: 'No file selected',
      fileTypeOptions: {
        proofOfDelivery: 'Proof of Delivery',
        customsInvoice: 'Customs Declaration Invoice',
        customsPackingList: 'Customs Declaration Packing List',
        customsContract: 'Customs Declaration Contract',
        clearanceInvoice: 'Customs Clearance Invoice',
        clearancePackingList: 'Customs Clearance Packing List',
        bookingNote: 'Booking Note',
        supplierBill: 'Supplier Bill',
        expressWaybill: 'Express Waybill',
        batteryLetter: 'Battery Letter',
        certificateOfOrigin: 'Certificate of Origin',
        finalReviewNotice: 'Final Review Notice'
      }
    },
    importReport: {
      title: 'Import Report',
      searchPlaceholder: 'Search title / product model / cert body',
      selectedCount: '{count} selected',
      confirm: 'Confirm ({count} selected)',
      duplicateSkipped: 'Some reports were already imported and skipped',
      categories: {
        'cert-type-root': 'Certificate Type',
        'cert-emc-rf': 'EMC/RF/Safety',
        'cert-agency': 'Agency Service',
        'cert-function': 'Function/Performance',
        'cert-chemical': 'Chemical',
        'cert-energy': 'Energy Efficiency',
        'cert-training': 'Training/Consulting',
        'cert-factory': 'Factory Audit',
        'cert-bio': 'Biological',
        'cert-authorization': 'Authorization',
        'cert-network': 'Network Security',
        'cert-transport': 'Transport',
        'cert-registration': 'Registration',
        'cert-other': 'Other'
      },
      noSelection: 'Please select reports to import',
      success: 'Reports imported successfully',
      failed: 'Failed to import reports, please try again',
      columns: {
        countryRegion: 'Country/Region',
        title: 'Title',
        productCategory: 'Product Category',
        certType: 'Certificate Type',
        certProject: 'Certification Project',
        productModel: 'Product Model',
        certOrg: 'Cert Body',
        effectiveDate: 'Effective Date',
        expiryDate: 'Expiry Date',
        actions: 'Actions'
      }
    },
    printModal: {
      title: 'Print',
      description: 'Select a template and generate the print document',
      template: 'Print Template',
      templatePlaceholder: 'Please select a print template',
      templatesLoading: 'Loading templates...',
      noTemplates: 'No templates available',
      bill: 'Bill',
      billPlaceholder: 'Please select a bill',
      noBills: 'No bills are available for this consignment',
      orderIdMissing: 'Order ID is missing, cannot print',
      fileName: 'File Name',
      fileNamePlaceholder: 'Enter file name',
      fileNameSuffix: '(extension is appended automatically)',
      fileType: 'File Type',
      fileTypePlaceholder: 'Please select file type',
      fileTypeOptions: {
        bookingNote: 'Booking Note',
        supplierBill: 'Supplier Bill'
      },
      saveToFileManagement: 'Save to File Management',
      cancelButton: 'Cancel',
      generateButton: 'Generate',
      generatingButton: 'Generating...',
      generateSuccess: 'Print document generated successfully',
      generateFailed: 'Failed to generate the print document',
      generateAndSaveSuccess: 'Print document generated and saved to file management',
      exportThenSaveTip: 'The report is open. Select an export format in the viewer and the file will be saved to file management automatically',
      saveToFileManagementFailed: 'Failed to save to file management',
      templateDocumentMissing: 'The selected template has no cloud storage file. Save the template design first before saving to file management',
      statusRecordFailed: 'Print document generated, but recording the business status failed. Please contact the administrator',
      templateRequired: 'Please select a print template',
      fileNameRequired: 'Please enter a file name',
      fileTypeRequired: 'Please select a file type',
      billRequired: 'Please select a bill',
      loadTemplatesFailed: 'Failed to load print template list',
      loadBillsFailed: 'Failed to load consignment bills'
    }
  },
  externalCommon: {
    language: {
      zh: '中文',
      en: 'EN'
    },
    readonly: 'Read-only',
    required: 'Required',
    saved: 'Saved',
    empty: {
      route: 'No route information',
      contactAddress: 'No shipper/consignee/notify information',
      containerGroup: 'No container group information',
      vehicleGroup: 'No vehicle group information',
      bulkCargo: 'No cargo information',
      cargoGroup: 'No cargo group information',
      productInfo: 'No product details',
      quotationDetail: 'No quotation details',
      filesFromConsignor: 'No files provided by the consignor',
      waybill: 'No waybill. Add a waybill to continue.',
      packing: 'No packing list',
      trackingNode: 'No tracking node configuration',
      supplierFiles: 'No supplier uploaded files',
      businessStatus: 'No operation time records'
    },
    sections: {
      consignmentNo: 'Consignment No.',
      basicInfo: 'Basic Information',
      supplierInfo: 'Supplier Information',
      routeInfo: 'Route Information',
      contactAddress: 'Shipper / Consignee / Notify',
      productInfo: 'Product Details',
      quotationDetail: 'Quotation Details',
      filesFromConsignor: 'Consignor Attachments',
      waybillList: 'Waybill List',
      packingList: 'Packing List',
      trackingNodes: 'Tracking Nodes',
      businessStatus: 'Operation Time Records'
    },
    fields: {
      consignmentNo: 'Consignment No.',
      entrustCompany: 'Entrusting Company',
      tradeTerms: 'Trade Terms',
      transportTerms: 'Transport Terms',
      mainlineMode: 'Mainline Transport Mode',
      goodsReadyTime: 'Goods Ready Time',
      goodsType: 'Goods Type',
      cargoType: 'Cargo Type',
      goodsValue: 'Goods Value',
      productName: 'Product Name',
      hsCode: 'HS Code',
      expectShipDate: 'Expected Shipping Time',
      expectArrivalDate: 'Expected Arrival Time',
      supplierName: 'Supplier Name',
      contactName: 'Contact',
      contactPhone: 'Phone',
      email: 'Email',
      type: 'Type',
      company: 'Company',
      country: 'Country',
      province: 'Province/State',
      city: 'City',
      district: 'District',
      address: 'Address',
      status: 'Status',
      exceptionLevel: 'Exception Level',
      estimatedTime: 'Estimated Time',
      actualTime: 'Actual Time',
      exceptionType: 'Exception Type',
      estimatedRemark: 'Estimated Remark',
      actualRemark: 'Actual Remark',
      exceptionRemark: 'Exception Remark',
      supplierRemark: 'Supplier Remark'
    },
    partyTypes: {
      shipper: 'Shipper',
      consignee: 'Consignee',
      notify: 'Notify Party',
      shipperAddress: 'Shipper Address',
      consigneeAddress: 'Consignee Address',
      notifyAddress: 'Notify Address',
      actualPickup: 'Actual Pickup Address',
      actualDelivery: 'Actual Delivery Address'
    },
    routeTypes: {
      originWarehouse: 'Origin Warehouse',
      originLocation: 'Origin',
      originCountry: 'Origin Country',
      loadingPort: 'Loading Port',
      loadingAirport: 'Origin Airport',
      loadingHub: 'Origin Hub',
      destinationPort: 'Destination Port',
      destinationAirport: 'Destination Airport',
      destinationHub: 'Destination Hub',
      destinationCountry: 'Destination Country',
      destinationLocation: 'Destination',
      destinationWarehouse: 'Destination Warehouse'
    },
    routeAddress: {
      expand: 'Expand',
      collapse: 'Collapse'
    },
    cargoGroupTitles: {
      container: 'Container Group',
      vehicle: 'Vehicle Group',
      bulkCargo: 'Cargo Information',
      cargo: 'Cargo Group'
    },
    cargoColumns: {
      containerType: 'Container Type',
      quantity: 'Qty',
      pieces: 'Packages',
      weightKgs: 'Weight (KGS)',
      sizeM: 'Size (LxWxH M)',
      vehicleType: 'Vehicle Type',
      brand: 'Brand',
      model: 'Model',
      vehicleLength: 'Length (M)',
      vehicleWidth: 'Width (M)',
      vehicleHeight: 'Height (M)',
      grossWeightKgs: 'Gross Weight (KGS)',
      cargoKind: 'Cargo Kind',
      tonnageMt: 'Tonnage (MT)',
      volumeCbm: 'Volume (CBM)',
      stowageFactor: 'Stowage Factor',
      packagingType: 'Packaging',
      packaging: 'Packaging',
      palletSize: 'Pallet Size',
      palletQty: 'Pallet Qty',
      remark: 'Remark'
    },
    productColumnResize: 'Drag to resize {column}; double-click to auto-fit. Use arrow keys to resize or Enter to auto-fit.',
    productColumns: {
      productName: 'Product Name',
      skuCode: 'SKU',
      relateFhNo: 'Related Shipping Request No.',
      pcsQty: 'Pieces',
      boxGauge: 'Standard Packing Quantity',
      actualBoxQty: 'Actual Cartons',
      unitPrice: 'Unit Price',
      amtnFh: 'Amount',
      cnDesc: 'Chinese Description',
      enDesc: 'English Description',
      hsCodeLine: 'HS Code'
    },
    transportSegmentLabels: {
      prePort: 'Pre-carriage',
      main: 'Main Leg',
      lastMile: 'Final Leg'
    },
    trackingStatuses: {
      PENDING: 'Pending',
      IN_PROGRESS: 'In Progress',
      COMPLETED: 'Completed'
    },
    trackingExceptionLevels: {
      normal: 'Normal',
      minor: 'Minor',
      major: 'Major',
      critical: 'Critical'
    },
    transitTypes: {
      direct: 'Direct',
      transit: 'Transit'
    },
    placeholders: {
      select: 'Please select',
      selectOrInput: 'Select or enter {field}',
      example: 'e.g. {value}',
      remark: 'Enter remarks',
      supplierRemark: 'Enter supplier remarks',
      waybillNo: 'Enter waybill no.',
      expressWaybillNo: 'Enter express waybill no.',
      seaBlNo: 'Enter HBL/MBL no.',
      airBlNo: 'Enter HAWB/MAWB no.',
      vesselName: 'Enter vessel name',
      voyageNo: 'Enter voyage no.',
      phone: 'Enter phone',
      vehicleLicence: 'Enter plate no.',
      vehicleType: 'Enter vehicle type',
      trainNo: 'Enter train no.',
      estimatedTime: 'Estimated time',
      actualTime: 'Actual time',
      exceptionType: 'Enter exception type',
      estimatedRemark: 'Enter estimated remark',
      actualRemark: 'Enter actual remark',
      exceptionRemark: 'Enter exception remark'
    }
  },
  quotationDetailTable: {
    empty: 'No quotation details',
    airRateUnits: {
      normal: 'Normal Rate',
      minimum: 'Min'
    },
    columns: {
      feeCategory: 'Fee Category',
      feeName: 'Fee Name',
      feeType: 'Fee Type',
      containerType: 'Container Type',
      chargeWeight: 'Weight Break',
      unit: 'Unit',
      currency: 'Currency',
      unitPrice: 'Unit Price',
      quantity: 'Qty',
      amount: 'Amount',
      originalUnitPrice: 'Original Unit Price',
      originalQuantity: 'Original Qty',
      originalAmount: 'Original Amount',
      confirmUnitPrice: 'Confirmed Unit Price',
      confirmQuantity: 'Confirmed Qty',
      confirmAmount: 'Confirmed Amount',
      diffAmount: 'Difference',
      diffRate: 'Difference Rate',
      operation: 'Action',
      remarks: 'Remark',
      min: 'Min',
      max: 'Max',
      densityDegree: 'Density Level'
    }
  },
  spaceInquiryModal: {
    title: 'Space Inquiry',
    summary: {
      consignmentNo: 'Consignment No.',
      origin: 'Origin',
      destination: 'Destination',
      expectedShip: 'Expected Ship'
    },
    completion: {
      completed: 'Completed',
      pending: 'Pending',
      warning: 'Complete all {title} fields on the consignment before sending the space inquiry email'
    },
    templateNames: {
      SEA_FCL: 'Ocean FCL - Space Confirmation Invite',
      SEA_LCL: 'Ocean LCL - Space Confirmation Invite',
      SEA_RORO: 'Sea RoRo - Space Confirmation Invite',
      SEA_BULK: 'Sea Bulk - Space Confirmation Invite',
      AIR: 'Air - Space Confirmation Invite',
      LAND_PRE_PORT: 'Pre-Port Road - Space Confirmation Invite',
      LAND_FINAL: 'Final-Mile Road - Space Confirmation Invite',
      localFallbackSuffix: 'Local fallback'
    },
    variables: {
      supplierContactName: 'Supplier Contact Name',
      entrustCompanyName: 'Entrusting Company',
      supplierName: 'Supplier Name',
      consignmentNo: 'Consignment No.',
      consignmentCompanyName: 'Consignment Company Name',
      transportSegment: 'Transport Segment',
      segmentTransportMode: 'Segment Transport Business Type',
      tradeTerms: 'Trade Terms',
      transportTerms: 'Transport Terms',
      cargoReadyTime: 'Goods Ready Time',
      goodsType: 'Goods Type',
      productName: 'Product Name',
      goodsValue: 'Goods Value',
      originWarehouse: 'Origin Warehouse',
      loadingPortName: 'Loading Port',
      originCountryName: 'Origin Country',
      destinationPortName: 'Destination Port',
      destinationCountryName: 'Destination Country',
      destinationPlace: 'Destination',
      cargoGroupTitle: 'Cargo/Container/Vehicle Info Title',
      containerGroupTable: 'Container Group Table',
      cargoGroupTable: 'Cargo/Container/Vehicle Info Table',
      quotationDetailTable: 'Quotation Detail Table',
      spaceInquiryUrl: 'Space Inquiry Confirmation Link',
      expectedDepartureTime: 'Expected Departure Time',
      expectedArrivalTime: 'Expected Arrival Time',
      spaceInquiryDeadline: 'Space Inquiry Deadline',
      contactName: 'Contact',
      contactPhone: 'Contact Phone',
      contactEmail: 'Email'
    },
    link: {
      title: 'Space Inquiry Link',
      copy: 'Copy'
    },
    report: {
      title: 'Supplier Space Report',
      tip: 'The supplier has submitted space information. Select the record to confirm the space. You can continue starting inquiries until the space is confirmed.',
      empty: 'No supplier space report is available for confirmation. Refresh and try again.',
      confirmTitle: 'Confirm Space',
      confirmContent: 'This will apply the schedule, voyage and confirmed space status. Continue?',
      columns: {
        bookingNo: 'Inquiry No.',
        submittedAt: 'Reported At',
        carrier: 'Carrier / Airline',
        transitType: 'Direct / Transit',
        transitPort: 'Transit Port / Airport',
        transitDays: 'Transit Days',
        vesselOrAircraft: 'Vessel / Aircraft',
        voyageOrFlight: 'Voyage / Flight No.',
        routeCode: 'Route Code',
        etd: 'ETD',
        eta: 'ETA',
        pickupTime: 'Pickup Time',
        supplierRemark: 'Supplier Remark'
      }
    },
    sendInfo: {
      title: 'Send Information',
      consignorOffice: 'Entrusting Company',
      consignorOfficePlaceholder: 'Select entrusting company',
      messageTemplate: 'Email Template',
      messageTemplatePlaceholder: 'Select email template',
      supplier: 'Supplier',
      supplierContact: 'Supplier Contact',
      supplierEmail: 'Supplier Email',
      recipientEmails: 'Recipient Emails',
      recipientEmailsPlaceholder: 'Select or enter recipient emails',
      emailContent: 'Email Content',
      editorHint: 'Rich text is supported. You can enter placeholders directly, for example: {variableToken}, {arrayToken}, {objectToken}',
      editorPlaceholder: 'Enter email content. Use {variableToken} as placeholders...'
    },
    attachments: {
      title: 'Attachments',
      addIsf: 'Show ISF in email template',
      addCabinetInvoice: 'Show container detail invoice in email template'
    },
    defaultEmail: {
      greeting: 'Dear <strong>{supplierContactName}</strong>,',
      intro: '<strong>{entrustCompanyName}</strong> invites <strong>{supplierName}</strong> to confirm the space information for the following consignment.',
      consignmentSummary: 'Consignment Summary',
      routeInfo: 'Route Information',
      quotationDetail: 'Quotation Details',
      participation: 'How to Participate',
      participationText: 'Please open the following link to confirm the space information and fill in voyage details such as carrier, vessel/voyage, ETD/ETA, etc.:',
      openLink: 'Open link: ',
      importantTime: 'Important Milestones',
      contactTip: 'If you have any questions, please contact us:',
      cooperation: 'We look forward to working with you.',
      closing: 'Best regards,',
      labels: {
        consignmentNo: 'Consignment No.',
        consignmentCompany: 'Consignment Company',
        transportSegment: 'Transport Segment',
        segmentTransportMode: 'Segment Transport Business Type',
        tradeTerms: 'Trade Terms',
        transportTerms: 'Transport Terms',
        cargoReadyTime: 'Goods Ready Time',
        goodsType: 'Goods Type',
        productName: 'Product Name',
        goodsValue: 'Goods Value',
        originWarehouse: 'Origin Warehouse',
        loadingPort: 'Loading Port',
        originCountry: 'Origin Country',
        destinationPort: 'Destination Port',
        destinationCountry: 'Destination Country',
        destinationPlace: 'Destination',
        expectedDepartureTime: 'Expected Departure Time',
        expectedArrivalTime: 'Expected Arrival Time',
        spaceInquiryDeadline: 'Space Inquiry Deadline',
        contactName: 'Contact',
        contactPhone: 'Phone',
        contactEmail: 'Email'
      }
    },
    actions: {
      cancel: 'Cancel',
      sendEmail: 'Send Email',
      confirmSpace: 'Confirm Space'
    },
    messages: {
      templateParamsParseFailed: 'Failed to parse space inquiry email template parameters',
      templateLoadFailed: 'Failed to load space inquiry email template. Local fallback template is used.',
      supplementalDetailLoadFailed: 'Failed to load supplemental space inquiry details',
      quotationBasicDataLoadFailed: 'Failed to load quotation detail basic data',
      copyUnsupported: 'This browser does not support automatic copy',
      orderIdRequired: 'Missing consignment ID. Cannot generate space inquiry link.',
      copySuccess: 'Copied',
      copyFailed: 'Copy failed',
      insertVariableFailed: 'Failed to insert space inquiry email variable',
      recipientRequired: 'Enter recipient emails',
      emailContentRequired: 'Enter email content',
      alreadyConfirmed: 'Space has been confirmed. Another space inquiry cannot be started.',
      reportSelectionRequired: 'Select the space report to confirm',
      confirmSuccess: 'Space confirmed',
      confirmFailed: 'Failed to confirm space'
    }
  },
  spaceBookingExternal: {
    title: 'Space Confirmation',
    subtitle: 'Confirm consignment information and fill in voyage information',
    infoTip: 'This is an external supplier link for this space inquiry only. Confirm the information, fill in voyage details, and submit.',
    submitted: {
      title: 'Space inquiry submitted',
      description: 'The space report has been submitted and is awaiting confirmation from the consignor. Thank you.',
      submittedTime: 'Submitted at: {time}'
    },
    voyage: {
      title: 'Voyage Information',
      carrier: 'Carrier',
      vesselName: 'Vessel Name',
      voyageNo: 'Voyage No.',
      routeCode: 'Route Code',
      etd: 'ETD',
      eta: 'ETA',
      airline: 'Airline',
      aircraftType: 'Aircraft Type',
      flightNo: 'Flight No.',
      pickupTime: 'Pickup Time',
      transitType: 'Direct / Transit',
      transitPort: 'Transit Port',
      transitDays: 'Transit Days',
      supplierRemark: 'Supplier Remark'
    },
    actions: {
      submit: 'Submit Space Inquiry'
    },
    confirmDialog: {
      title: 'Submit space inquiry information?',
      content: 'After submission, the space status will become confirmed and the information cannot be changed.',
      okText: 'Submit'
    },
    messages: {
      submitSuccess: 'Space inquiry submitted',
      submitFailed: 'Failed to submit space inquiry. Please try again.',
      linkIdRequired: 'Missing space inquiry link ID',
      loadDisplayNameFailed: 'Failed to resolve space inquiry display names',
      carrierLoadFailed: 'Failed to load shipping company data',
      airlineLoadFailed: 'Failed to load airline data',
      loadFailed: 'Failed to load space inquiry information',
      submitHint: 'After submission, the space status will become confirmed and the information cannot be changed'
    }
  },
  supplierConfirmExternal: {
    title: 'Consignment Confirmation',
    infoTip: 'This is an external supplier link for this consignment confirmation only. After clicking "Accept Consignment", you can view subsequent attachments, cargo and tracking information.',
    headerDescription: {
      pending: 'Confirm consignment information and accept the consignment',
      consigned: 'Consignment accepted. Fill in waybill information, cargo information and upload related files.'
    },
    confirmHint: {
      cctower: 'After clicking, the consignment status will change to "Consigned"; you can reconcile fees, download attachments, and fill in cargo information.',
      normal: 'After clicking, the consignment status will change to "Consigned"; you can view subsequent attachments, cargo and tracking information.'
    },
    lockReasons: {
      external: 'The cargo was delivered more than 7 days ago. All fields are locked. Please contact the consignor if needed.',
      reconciliationApproved: 'Supplier reconciliation has been approved and quotation details are confirmed. Waybill, cargo and other information can still be edited.',
      reconciliationPending: 'Supplier reconciliation has been submitted for approval and quotation details cannot be edited. Waybill, cargo and other information can still be edited.'
    },
    rejected: {
      title: 'Reconciliation approval rejected',
      reason: 'Reject reason: {reason}',
      defaultReason: 'No reject reason was provided by the approver',
      action: 'Adjust fees according to the rejection comments and submit reconciliation again.'
    },
    waybill: {
      title: 'Waybill List',
      add: 'Add Waybill',
      requiredTip: 'End-to-end consignments require pre-carriage, main leg and final leg waybills. Required waybills cannot be deleted.',
      requiredTipFull: 'End-to-end consignments require pre-carriage, main leg and final leg waybills. Required waybills cannot be deleted.',
      requiredTipPreMain: 'Pre-carriage + main leg consignments require pre-carriage and main leg waybills. Required waybills cannot be deleted.',
      requiredTipMainLast: 'Main leg + final leg consignments require main leg and final leg waybills. Required waybills cannot be deleted.',
      requiredTag: 'Required',
      submittedTag: 'Submitted',
      displayNo: 'Waybill {index}',
      segmentTitle: '{segment} Waybill',
      deleteRequiredTitle: 'Pre-carriage, main leg and final leg waybills are required for an end-to-end consignment and cannot be deleted',
      deleteRequiredTitleFull: 'Pre-carriage, main leg and final leg waybills are required for an end-to-end consignment and cannot be deleted',
      deleteRequiredTitlePreMain: 'Pre-carriage and main leg waybills are required for a pre-carriage + main leg consignment and cannot be deleted',
      deleteRequiredTitleMainLast: 'Main leg and final leg waybills are required for a main leg + final leg consignment and cannot be deleted',
      baseInfo: 'Waybill Basic Information',
      copyVoyage: 'Copy Voyage Information',
      saveWaybill: 'Save Waybill',
      submitWaybill: 'Submit Waybill',
      businessType: 'Transport Business Type',
      transportSegment: 'Transport Segment',
      selectTransportSegment: 'Select Segment',
      routeLockedAfterSave: 'The business type and transport segment are locked after the first save',
      changeRouteTitle: 'Change waybill type?',
      changeRouteContent: 'Fields that do not apply to the new business type will be cleared. Continue?',
      blType: 'Waybill Type',
      airBlNo: 'Air Waybill No.',
      seaBlNo: 'B/L No.',
      airBlHint: 'Air: HAWB/MAWB',
      seaBlHint: 'Ocean: HBL/MBL',
      expressWaybillNo: 'Express Waybill No.',
      railwayWaybillNo: 'Railway Waybill No.',
      carrierWaybillNo: 'Carrier Waybill No.',
      vesselName: 'Vessel Name',
      voyageNo: 'Voyage No.',
      flightNo: 'Flight No.',
      routeCode: 'Route Code',
      airline: 'Airline',
      expressCompany: 'Express Company',
      expressProduct: 'Express Product',
      vehicleLicence: 'Plate No.',
      driverName: 'Driver Name',
      driverPhone: 'Phone',
      driverIdNo: 'ID No.',
      vehicleType: 'Vehicle Type',
      carrier: 'Carrier',
      railwayCarrier: 'Railway Carrier',
      trainNo: 'Train No.',
      originPort: 'Port of Loading',
      destinationPort: 'Port of Discharge',
      originAirport: 'Origin Airport',
      destinationAirport: 'Destination Airport',
      originPlace: 'Origin',
      destinationPlace: 'Destination',
      segmentOrigin: 'Segment Origin',
      segmentDestination: 'Segment Destination',
      supplierRemark: 'Supplier Remark',
      expand: 'Expand',
      collapse: 'Collapse',
      modeFallback: 'Waybill'
    },
    cargoSummary: {
      title: 'Actual Cargo Summary',
      summarizePacking: 'Summarize Packing List',
      save: 'Save Actual Cargo',
      pieces: 'Cartons',
      grossWeight: 'Gross Weight (KGS)',
      volume: 'Volume (CBM)',
      chargeableWeight: 'Chargeable Weight (KGS)',
      palletSize: 'Pallet Size (L×W×H cm)',
      palletSizePlaceholder: 'e.g. 120×80×100 or 120',
      palletQty: 'Pallet Qty'
    },
    packing: {
      title: 'Packing List',
      downloadTemplate: 'Download Template',
      importExcel: 'Import Excel',
      addRow: 'Add Row',
      operation: 'Action'
    },
    tracking: {
      title: 'Tracking Nodes',
      save: 'Save Tracking'
    },
    files: {
      download: 'Download',
      filesFromConsignor: 'Files Provided by Consignor',
      uploadSection: 'Upload Files',
      businessStatus: 'Operation Time Records'
    },
    upload: {
      title: 'Upload File',
      fileType: 'File Type',
      file: 'Upload File',
      chooseFile: 'Choose File',
      noFileSelected: 'No file selected'
    },
    importPacking: {
      title: 'Import Packing List',
      summary: '{count} packing rows parsed. Confirm to fill them into the current waybill.'
    },
    reconciliation: {
      acceptFirst: 'Accept the consignment before confirming fee reconciliation',
      successWithBill: 'Settlement bill {billNo} generated and pending approval',
      success: 'Settlement bill generated and pending approval',
      failed: 'Failed to confirm fee reconciliation. Please try again.'
    },
    quotationReconciliation: {
      editable: 'Editable',
      delete: 'Delete',
      addFee: 'Add Fee Item',
      emptyEditable: 'No fee items. Click the button below to add one.',
      infoTip: 'Review the fee items in quotation details. You can edit confirmed unit price/quantity, delete non-applicable fees, and add missing fees. After confirmation, the system will generate a settlement bill and submit it to the consignor BPM approval flow.',
      diffNote: 'Difference Note',
      optional: '(Optional)',
      commonReasons: 'Common Reasons',
      diffNotePlaceholder: 'Explain the fee adjustment for consignor approval. Example: fuel prices increased recently, so BAF changed from USD350 to USD420; origin THC changed from USD180 to USD200 due to operation rate adjustment.',
      submit: 'Confirm Reconciliation and Generate Settlement Bill',
      submitHint: 'After confirmation, a settlement bill will be generated and submitted to the consignor BPM approval flow.',
      currencyTotal: '{currency} Total {amount}',
      diffReasonSeparator: '; ',
      defaultSettlementObject: 'Supplier',
      feeCategories: {
        prePort: 'Pre-carriage',
        main: 'Main Leg',
        lastMile: 'Final Leg',
        fullJourney: 'Full Journey'
      },
      feeUnits: {
        container: 'Container',
        ticket: 'Ticket',
        day: 'Day'
      },
      feeNames: {
        truckingFee: 'Trucking Fee',
        customsDeclarationFee: 'Customs Declaration Fee',
        documentFee: 'Document Fee',
        loadingFee: 'Loading Fee',
        originThc: 'Origin THC',
        terminalSecurityFee: 'Terminal Security Fee',
        storageFee: 'Storage Fee',
        oceanFreight: 'Ocean Freight',
        baf: 'BAF (Bunker Adjustment Factor)',
        caf: 'CAF (Currency Adjustment Factor)',
        pss: 'PSS (Peak Season Surcharge)',
        ebs: 'EBS (Emergency Bunker Surcharge)',
        portHandlingFee: 'Port Handling Fee',
        billOfLadingFee: 'Bill of Lading Fee',
        destinationThc: 'Destination THC',
        railTransferFee: 'Rail Transfer Fee',
        bargeFee: 'Barge Fee',
        telexReleaseFee: 'Telex Release Fee',
        agencyFee: 'Agency Fee',
        liftOnOffFee: 'Lift-on/Lift-off Fee',
        fumigationFee: 'Fumigation Fee',
        inspectionFee: 'Inspection Fee',
        insuranceFee: 'Insurance Fee'
      },
      diffReasons: {
        truckingWaitingFeeIncrease: 'Trucking waiting fee increased',
        customsInspectionExtraFee: 'Customs inspection incurred extra fees',
        originOperationRateChange: 'Origin operation rate changed',
        fuelSurchargeChange: 'Fuel surcharge changed',
        spaceTightRateChange: 'Rate changed due to tight space',
        peakSeasonSurchargeChange: 'Peak season surcharge changed',
        destinationOperationRateChange: 'Destination operation rate changed',
        deliveryAddressSurcharge: 'Delivery address incurred a surcharge',
        storageOrDemurrageIncrease: 'Storage or demurrage fees increased'
      },
      messages: {
        duplicateFeeName: 'New fee names cannot be duplicated. Please select again.',
        duplicateFeeNameWithName: 'New fee name "{name}" cannot be duplicated.',
        diffNoteMax: 'Difference note cannot exceed 500 characters',
        emptyFees: 'Fee details cannot be empty',
        incompleteNewFee: 'Complete the fee category and fee name for the new fee item',
        noFeeChange: 'Modify at least one fee price before confirming reconciliation'
      }
    },
    actions: {
      accept: 'Accept Consignment'
    },
    confirmDialog: {
      acceptTitle: 'Accept this consignment?',
      acceptContent: 'After accepting transport consignment {consignmentNo}, the consignment status will be updated to Consigned.',
      acceptOk: 'Accept Consignment',
      deleteWaybillContent: 'Delete waybill {name}?',
      deleteContent: 'Delete {name}?'
    },
    messages: {
      downloadFileFailed: 'Failed to download file',
      resolveContainerTypeFailed: 'Failed to resolve container type names',
      resolveDisplayNameFailed: 'Failed to resolve consignment confirmation display names',
      tokenRequired: 'Missing consignment confirmation token',
      loadFailed: 'Failed to load consignment confirmation information',
      loadBusinessStatusFailed: 'Failed to load operation time records',
      loadCctowerModeFailed: 'Failed to load Dongfeng environment configuration',
      acceptSuccess: 'Consignment accepted',
      acceptFailed: 'Failed to accept consignment. Please try again.',
      saveWaybillSuccess: 'Waybill saved',
      saveWaybillFailed: 'Failed to save waybill',
      waybillModeRequired: 'Select a transport business type',
      waybillSegmentRequired: 'Select a transport segment',
      waybillRouteMismatch: 'The transport business type does not match the transport segment',
      saveWaybillFirst: 'Save waybill information first',
      cargoRequired: 'Enter cartons, gross weight and volume',
      saveCargoSuccess: 'Actual cargo information saved',
      saveCargoFailed: 'Failed to save actual cargo information',
      submitWaybillSuccess: 'Waybill submitted',
      submitWaybillFailed: 'Failed to submit waybill',
      noTrackingNodeToSave: 'No tracking nodes to save',
      saveTrackingSuccess: 'Tracking information saved',
      saveTrackingFailed: 'Failed to save tracking information',
      deleteWaybillTitle: 'Delete waybill?',
      deleteWaybillSuccess: 'Waybill deleted',
      downloadPackingTemplateFailed: 'Failed to download packing list template',
      importPackingFailed: 'Failed to import packing list',
      importPackingFallbackFailed: 'Import failed',
      importPackingSuccess: 'Packing list imported',
      uploadSupplierFileSuccess: 'File uploaded',
      uploadSupplierFileFailed: 'Failed to upload supplier file',
      deleteFileTitle: 'Delete file?',
      deleteFileSuccess: 'File deleted'
    }
  },
  fields: {
    consignmentNo: 'Transport Consignment No.',
    orderStatus: 'Main Status',
    mergeStatus: 'Consignment Status',
    priceStatus: 'Rate Status',
    shippingSpaceStatus: 'Space Status',
    transportSegment: 'Transport Segment',
    relatePlanNo: 'Related Transport Plan No.',
    relateFhNo: 'Related Shipping Request No.',
    businessCategory: 'Business Category',
    fhCateg: 'Business Category Code',
    fhCategName: 'Business Category Name',
    regionCodePath: 'Region Code',
    regionPath: 'Region',
    costCenter: 'Cost Center Code',
    costCenterName: 'Cost Center',
    salesType: 'Sales Mode Code',
    salesTypeName: 'Sales Mode Name',
    bizDept: 'Business Department Code',
    departmentName: 'Business Department',
    relateConsignmentNo: 'Related Transport Consignment No.',
    orderSource: 'Source',
    sourceType: 'Source Type',
    goodsType: 'Goods Info',
    cusShortName: 'Customer Short Name',
    cusName: 'Customer Name',
    cusNo: 'Customer Code',
    customerNames: 'Customer',
    originWh: 'Shipping Warehouse',
    createdAt: 'Created Time',
    creator: 'Creator',
    omsRemark: 'Order Remark',
    logisticsOperator: 'Logistics Operator',
    updatedAt: 'Updated Time',
    consignor: 'Consignor Company',
    customerConsignment: 'Customer Appointed',
    customsTradeTerm: 'Trade Term (Customs)',
    clearanceTradeTerm: 'Trade Term (Clearance)',
    transportTerms: 'Transport Terms',
    segmentTransportMode: 'Segment Transport Business Type',
    hopeSegmentTransportMode: 'Expected Segment Transport Business Type',
    segmentOrigin: 'Segment Origin',
    segmentDestination: 'Segment Destination',
    destinationWh: 'Destination Warehouse',
    destinationWhCode: 'Destination Warehouse Code',
    mainlineOriginCountry: 'Mainline Origin Country',
    mainlineDestCountry: 'Mainline Destination Country',
    portOfLoadingCode: 'Port of Loading',
    portOfDischargeCode: 'Port of Discharge',
    expectShipDate: 'Expected Shipping Time',
    actShipDate: 'Actual Shipping Time',
    expectArrivalDate: 'Expected Arrival Time',
    actArrivalDate: 'Actual Arrival Time',
    productName: 'Product Name',
    englishProductName: 'English Product Name',
    chineseProductName: 'Chinese Product Name',
    shippingMark: 'Shipping Mark',
    hsCode: 'HS Code',
    originCountry: 'Country of Origin',
    customsFlag: 'Customs Declaration',
    customsType: 'Customs Type',
    exchangeRate: 'Exchange Rate',
    amountCurrency: 'Total Amount - Currency',
    taxCurrency: 'Total Tax - Currency',
    totalAmount: 'Total Amount - Amount',
    totalTax: 'Total Tax - Tax',
    clearanceCurrency: 'Clearance Goods Value - Currency',
    totalAmountQg: 'Clearance Goods Value - Amount',
    cargoType: 'Cargo Type',
    goodsReadyTimeType: 'Goods Ready Time - Type',
    goodsReadyPeriod: 'Goods Ready Time - Period',
    goodsReadyDate: 'Goods Ready Time - Date',
    goodsReadyTime: 'Goods Ready Time - Date',
    tmsRemark: 'Transport Remark',
    bizTags: 'Business Tags',
    volumeUnit: 'Volume Unit',
    weightUnit: 'Weight Unit',
    lengthUnit: 'Length Unit',
    weightCount: 'Chargeable Weight Unit',
    totalQtyExpect: 'Expected Total Qty',
    totalVolumeExpect: 'Expected Total Volume',
    totalWeightExpect: 'Expected Total Weight',
    lengthExpect: 'Expected Length',
    widthExpect: 'Expected Width',
    heightExpect: 'Expected Height',
    totalWeightCountWh: 'Warehouse Chargeable Weight',
    totalVolumeSupplier: 'Forwarder Total Volume',
    totalWeightSupplier: 'Forwarder Total Weight',
    totalWeightCountSupplier: 'Forwarder Chargeable Weight',
    supplierCode: 'Supplier Code',
    supplierSn: 'Supplier Short Name',
    supplierName: 'Supplier Name',
    contactName: 'Contact',
    contactPhone: 'Phone',
    email: 'Email',
    consignMailStatus: 'Consignment Email Status',
    priceConfirmStatus: 'Rate Confirmation Status',
    shippingSpaceConfirmStatus: 'Space Confirmation Status',
    feeConfirmStatus: 'Fee Confirmation Status',
    relateInquiryNo: 'Related Inquiry No.',
    relatePriceNo: 'Related Rate No.',
    currentTrackingNode: 'Current Tracking Node',
    supplierConfirmExternalLink: 'Supplier Consignment Link',
    operation: 'Operation'
  },
  filterFields: {
    consignmentNo: 'Consignment No.',
    supplier: 'Supplier'
  },
  placeholders: {
    consignmentNo: 'Enter consignment no.; separate multiple values with comma/space',
    orderStatus: 'Select main status',
    mergeStatus: 'Select consignment status',
    priceStatus: 'Select rate status',
    shippingSpaceStatus: 'Select space status',
    feeConfirmStatus: 'Select fee confirmation status',
    transportSegment: 'Select transport segment',
    segmentTransportMode: 'Select segment transport business type',
    hopeSegmentTransportMode: 'Select expected segment transport business type',
    supplierName: 'Select supplier name',
    supplierShortName: 'Select supplier short name',
    segmentOrigin: 'Select segment origin',
    segmentDestination: 'Select segment destination',
    destinationWh: 'Select destination warehouse',
    destinationWhCode: 'Select destination warehouse code',
    mainlineOriginCountry: 'Select mainline origin country',
    mainlineDestCountry: 'Select mainline destination country',
    portOfLoading: 'Enter port of loading code',
    portOfDischarge: 'Enter port of discharge code',
    currentTrackingNode: 'Select or enter current tracking node',
    keyword: 'Enter keyword',
    bizTagsSelect: 'Enter or select business tags',
    batchKeyword: 'Enter keywords; separate multiple values with comma/space',
    select: 'Select',
    dateRange: 'Select date range',
    number: 'Enter number'
  },
  enums: {
    transportSegment: {
      prePort: 'Pre-carriage',
      main: 'Main Leg',
      final: 'Final Leg',
      full: 'End-to-end',
      preMain: 'Pre-carriage + Main Leg',
      mainLast: 'Main Leg + Final Leg'
    },
    transportMode: {
      fcl: 'Ocean FCL',
      lcl: 'Ocean LCL',
      air: 'Air',
      road: 'Road',
      rail: 'Rail',
      express: 'Express',
      roro: 'Sea RoRo',
      bulk: 'Sea Bulk',
      other: 'Other'
    },
    orderStatus: {
      created: 'Created',
      picking: 'Picking',
      operating: 'Operating',
      completed: 'Completed',
      frozen: 'Frozen',
      cancelled: 'Cancelled',
      approving: 'Approving'
    },
    consignmentStatus: {
      notConsigned: 'Not Consigned',
      consigned: 'Consigned',
      cancelled: 'Cancelled'
    },
    confirmStatus: {
      unconfirmed: 'Unconfirmed',
      confirmed: 'Confirmed',
      irrelevant: 'Irrelevant'
    },
    shippingSpaceStatus: {
      reported: 'Reported'
    },
    consignMailStatus: {
      unsent: 'Unsent',
      sent: 'Sent'
    },
    goodsType: {
      standard: 'Standard Product',
      marketing: 'Marketing Material',
      rawMaterial: 'Raw Material',
      gift: 'Gift'
    },
    trackingNode: {
      collected: 'Collected',
      inTransit: 'In Transit',
      delivering: 'Delivering',
      signed: 'Signed',
      exception: 'Exception'
    },
    trackingSource: {
      expressApi: 'Express API',
      manual: 'Manual'
    }
  },
  expressOrderDialog,
  messages: {
    loadListFailed: 'Failed to load transport consignment list',
    loadDetailFailed: 'Failed to load transport consignment detail',
    detailIdMissing: 'Transport consignment ID is missing; details cannot be loaded',
    loadFeeFailed: 'Failed to load transport consignment fees',
    loadCountryFailed: 'Failed to load country data',
    loadDivisionFailed: 'Failed to load administrative division data',
    loadOfficeFailed: 'Failed to load company structure data',
    transportPlanNotFound: 'Transport plan [{no}] was not found; its details cannot be opened',
    transportPlanOpenFailed: 'Failed to open transport plan details, please try again',
    distributionShipmentNotFound: 'Shipment request [{no}] was not found; its details cannot be opened',
    distributionShipmentOpenFailed: 'Failed to open shipment request details, please try again',
    createSuccess: 'Transport consignment created',
    createFailed: 'Failed to create transport consignment',
    saveSuccess: 'Transport consignment saved',
    saveFailed: 'Failed to save transport consignment',
    customerSnapshotUnresolvedReadonly: 'Some historical customer links could not be restored. Customer fields are read-only, while other fields can still be saved.',
    customerFieldNotMaintained: '{field} not maintained ({customer})',
    rateSelectRequired: 'Select one rate first',
    ratePriceNoRequired: 'The selected rate has no rate code and cannot be confirmed',
    rateSupplierRequired: 'The selected rate has no supplier enterprise and cannot be confirmed',
    rateConfirmSuccess: 'Rate confirmed',
    rateConfirmFailed: 'Failed to confirm rate, please try again',
    rateDetailMissing: 'Rate ID is missing, cannot open fee details',
    loadFilesFailed: 'Failed to load transport consignment files',
    loadBusinessStatusFailed: 'Failed to load transport consignment business status',
    fileIdMissing: 'File ID does not exist',
    fileRecordIdMissing: 'File record ID does not exist',
    orderIdMissing: 'Order ID does not exist, cannot upload file',
    fileTypeRequired: 'Please select file type',
    fileRequired: 'Please select a file',
    uploadSuccess: 'Uploaded successfully',
    uploadFailed: 'Upload failed, please try again',
    fedexFileRetryOrderMissing: 'The express order record is missing; FedEx files cannot be retried',
    fedexFileRetrySuccess: 'FedEx files were uploaded to eTower successfully',
    fedexFileRetryFailed: 'Failed to upload FedEx files again, please try later',
    downloadSuccess: 'Download started',
    downloadFailed: 'Download failed, please try again',
    deleteFileSuccess: 'File deleted',
    deleteFileFailed: 'Failed to delete file, please try again',
    customerVisibleUpdateSuccess: 'Customer visibility updated',
    customerVisibleUpdateFailed: 'Failed to update customer visibility, please try again',
    inquirySuccess: 'Inquiry sent. Inquiry No.: {no}',
    inquiryAndRateSuccess: 'Rate confirmed and inquiry sent. Inquiry No.: {no}',
    inquiryFailed: 'Failed to send inquiry',
    spaceInquiryEmailFailed: 'Failed to send space inquiry email, please try again',
    supplierEmailFailed: 'Failed to send supplier email, please try again',
    cancelConsignmentFailed: 'Failed to cancel consignment, please try again',
    deleteConsignmentFailed: 'Failed to delete consignment, please try again',
    consignedRateChangeForbidden: 'Transport consignment [{no}] has been consigned and its rate cannot be changed',
    inquiryFclOnly: 'Only FCL, LCL, Sea RoRo, Sea Bulk, air, pre-port and last-mile inquiry sending are supported currently',
    inquiryTransportTermsRequired: 'Select transport terms',
    inquiryCargoTypeRequired: 'Select cargo type',
    inquiryDeadlineRequired: 'Select a quote deadline',
    inquiryDeadlineFutureRequired: 'The quote deadline must be later than the current time',
    inquiryContactRequired: 'Select inquiry target supplier contacts',
    inquiryContactEmailRequired: 'Selected supplier contacts must have email addresses',
    inquiryContainerRequired: 'Enter at least one valid container type',
    inquiryCargoRequired: 'Enter at least one valid cargo item',
    inquiryVehicleRequired: 'Enter at least one valid vehicle',
    inquiryBulkCargoRequired: 'Enter at least one valid bulk cargo item',
    inquiryContainerCompleteRequired: 'Complete all container group fields before confirming',
    inquiryCargoCompleteRequired: 'Complete all cargo group fields before confirming',
    inquiryVehicleCompleteRequired: 'Complete all vehicle group fields before confirming',
    inquiryBulkCargoCompleteRequired: 'Complete all cargo info fields before confirming',
    contactPartyRequired: 'Exactly one shipper and one consignee are required',
    contactAddressRequired: 'Contact, phone and country are required',
    customsContactAddressRequired: 'Phone is required for customs and clearance addresses',
    customsCountryLookupFailed: 'Unable to determine the port country. Please check the port data and retry',
    provinceMustBeSelected: 'Select the province/state in contact address row {row} from the search results',
    contactAddressIncompleteForSupplier: 'Complete the required address fields before delegating or contacting a supplier; only phone is required for customs and clearance addresses',
    amountNumberRequired: 'Amount fields must be numeric',
    vehicleGroupAtLeastOne: 'Keep at least one vehicle info row',
    bulkCargoInfoAtLeastOne: 'Keep at least one bulk cargo info row',
    vehicleGroupRequiredFields: 'Complete vehicle info row {row}: vehicle type and qty are required, and qty must be an integer greater than or equal to 1',
    bulkCargoInfoRequiredFields: 'Complete bulk cargo info row {row}: cargo kind and tonnage are required, and tonnage must be greater than 0',
    productAtLeastOneRequired: 'At least one product detail row is required',
    productRequired: 'Complete required product fields: product name, qty and unit',
    productFirstInvalidField: 'Product detail row {rowIndex}: enter {field}',
    productQtyInvalid: 'Product detail row {rowIndex}: qty must be an integer greater than or equal to 1',
    productImportEmpty: 'No valid product detail rows were found',
    productImportSuccess: 'Imported {count} product detail rows',
    productImportFailed: 'Failed to import product details. Check the template format',
    offlineConfirmOrderIdRequired: 'Consignment ID is missing; offline supplier delegation cannot be completed',
    offlineConfirmSuccess: 'Offline supplier delegation completed. Consignment status was updated to Consigned',
    offlineConfirmFailed: 'Failed to delegate supplier offline, please try again',
    offlineSupplierStatusInvalid: 'Only transport consignments with main status Created or In Operation and consignment status Not Entrusted can be delegated offline',
    offlineSupplierNameRequired: 'Select supplier',
    supplierSelectionRequired: 'Select supplier',
    offlineSupplierEmailInvalid: 'Enter a valid email',
    unfreezeOrderIdRequired: 'Consignment ID is missing; cannot unfreeze',
    unfreezeStatusDisabled: 'Only frozen transport consignments can be unfrozen',
    unfreezeSuccess: 'Transport consignment unfrozen',
    unfreezeFailed: 'Failed to unfreeze transport consignment, please try again',
    notifyPickingDisabled: 'Notify picking is available only after the consignment status is Consigned',
    batchFeeSelectRequired: 'Select transport consignments first',
    batchFeeConfirmSuccess: 'Confirmed fees for {count} consignments',
    batchFeeCancelConfirmSuccess: 'Canceled fee confirmation for {count} consignments',
    batchFeeConfirmFailed: 'Failed to update fee confirmation status, please try again',
    batchCompleteSelectRequired: 'Select transport consignments to complete first',
    batchCompleteLoadFailed: 'Failed to load waybills for batch completion, please try again',
    batchCompleteSuccess: 'Completed {count} consignments',
    batchCompleteFailed: 'Batch completion failed, please try again',
    operationPending: '{action} is pending implementation. Consignment: {no}',
    reportNoFile: 'The selected report has no file',
    loadReportFailed: 'Failed to load document control reports'
  }
}
